import DataMapper from './DataMapper'
import CaseCategoryRM from '../responsemodel/CaseCategoryRM'
import CaseCategory from '../../models/CaseCategory'

export default class CaseCategoryDataMapper extends DataMapper<CaseCategoryRM, CaseCategory> {
  map = (rm: CaseCategoryRM) => new CaseCategory(rm.id, rm.name, rm.code, rm.activated)
}
